import React, { useState, useEffect } from 'react';

const LoadingGate = ({ isLoading }) => {
  const [showGate, setShowGate] = useState(true);

  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => setShowGate(false), 2000);
    }
  }, [isLoading]);

  if (!showGate) return null;

  return (
    <div className={`loading-gate ${isLoading ? '' : 'opening'}`}>
      <div className="gate left-gate"></div>
      <div className="gate right-gate"></div>
      <div className="loading-content">
        <div className="loading-spinner"></div>
        <h2>Loading...</h2>
      </div>
    </div>
  );
};

export default LoadingGate;